/**
 * Instance Advice UI state — which view is shown, the Savings Type filter,
 * and the columns the user hid with Customize Table.
 *
 * In a slice (not page state) because it outlives one visit, as legacy's
 * Vuex `selectedViewMode` / `savingsType` / `columnVisibility` did: open
 * another portfolio's advice and the same view and columns are shown.
 * Opening the page FROM a portfolio's Instance Advice button starts on
 * Analytics again (legacy RedirectCostAdvice updateViewMode(0)).
 * Legacy bug not carried over: it reset the column choices every time the
 * filters row mounted, so the "persisted" choice was lost. Here it is kept.
 * Server data is not here — it lives in the page's useAdvice.
 */
import { createSlice } from '@reduxjs/toolkit';

import { ADVICE_VIEWS, SAVINGS_ALL } from './adviceRules';

const initialState = {
  view: ADVICE_VIEWS.ANALYTICS,
  savingsType: SAVINGS_ALL,
  /** Column ids hidden by Customize Table (see adviceColumns.js). */
  hiddenColumns: [],
};

const costAdviceSlice = createSlice({
  name: 'costAdvice',
  initialState,
  reducers: {
    setAdviceView(state, action) {
      if (Object.values(ADVICE_VIEWS).includes(action.payload)) state.view = action.payload;
    },
    setSavingsType(state, action) {
      state.savingsType = action.payload || SAVINGS_ALL;
    },
    setHiddenColumns(state, action) {
      state.hiddenColumns = Array.isArray(action.payload) ? [...action.payload] : [];
    },
  },
});

export const { setAdviceView, setSavingsType, setHiddenColumns } = costAdviceSlice.actions;

export const selectAdviceView = (s) => s.costAdvice?.view ?? ADVICE_VIEWS.ANALYTICS;
export const selectSavingsType = (s) => s.costAdvice?.savingsType ?? SAVINGS_ALL;
const NO_COLUMNS = Object.freeze([]);
export const selectHiddenColumns = (s) => s.costAdvice?.hiddenColumns ?? NO_COLUMNS;

export default costAdviceSlice.reducer;
